import { AxiosHeaders, type InternalAxiosRequestConfig } from 'axios';
import { isRecord } from 'utils/typeGuards';

/** Set a request header, including configs supplied with plain-object headers. */
export function setHeader(
  config: InternalAxiosRequestConfig,
  key: string,
  value: string
): void {
  if (!config.headers) config.headers = new AxiosHeaders();
  if (typeof config.headers.set === 'function') {
    config.headers.set(key, value);
  } else {
    config.headers[key] = value;
  }
}

/** Read a string response/request header without assuming its casing. */
export function readHeader(headers: unknown, key: string): string | null {
  if (headers instanceof AxiosHeaders) {
    const value = headers.get(key);
    return typeof value === 'string' ? value : null;
  }
  if (!isRecord(headers)) return null;
  const lowerKey = key.toLowerCase();
  for (const name of Object.keys(headers)) {
    const value = headers[name];
    if (name.toLowerCase() === lowerKey && typeof value === 'string')
      return value;
  }
  return null;
}

/** Whether request headers carry a value, preserving each container's semantics. */
export function hasHeader(headers: unknown, key: string): boolean {
  if (headers instanceof Headers) return Boolean(headers.get(key));
  if (headers instanceof AxiosHeaders) return Boolean(headers.get(key));
  if (!isRecord(headers)) return false;
  if (headers[key] != null) return true;
  const lowerKey = key.toLowerCase();
  return Object.keys(headers).some(
    (name) => name.toLowerCase() === lowerKey && headers[name] != null
  );
}
